import Image from "components/Image"
import styled from "@emotion/styled"

const ListTwoCardCover = styled(Image)`
  height: 262px;
  border-radius: 20px 20px 0 0;
  margin-bottom: 48px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    margin-bottom: 30px;
  }
`

export default ListTwoCardCover
